import { render, staticRenderFns } from "./EditableImage.vue?vue&type=template&id=1ceb5640&scoped=true"
import script from "./EditableImage.vue?vue&type=script&lang=js"
export * from "./EditableImage.vue?vue&type=script&lang=js"
import style0 from "./EditableImage.vue?vue&type=style&index=0&id=1ceb5640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb5640",
  null
  
)

export default component.exports